import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import { RULES_CONSTANT } from 'constant/RuleConstant';
import { RuleParameterOption } from '../types';
import { EditorField, EditorSectionCard, editorControlStyles } from './EditorSectionCard';

export function KTreeConfigurationSection({
  ruleTypeCode,
  kTreeOptions,
  isLoading,
  ktreeDefinition,
  inferenceKTreeDefinition,
  onKTreeChange,
  onInferenceKTreeChange,
  disabled = false,
}: {
  ruleTypeCode?: string;
  kTreeOptions: RuleParameterOption[];
  isLoading: boolean;
  ktreeDefinition: RuleParameterOption | null;
  inferenceKTreeDefinition: RuleParameterOption | null;
  onKTreeChange: (value: RuleParameterOption | null) => void;
  onInferenceKTreeChange: (value: RuleParameterOption | null) => void;
  disabled?: boolean;
}) {
  const isInferenceRule =
    ruleTypeCode === RULES_CONSTANT.ASSOCIATED_SUBJECT.RULE_KTREE_PARENT_ATTRIBUTE_INFERENCE;

  return (
    <EditorSectionCard
      icon={<AccountTreeOutlinedIcon fontSize='small' />}
      title='KTree configuration'
      description={
        isInferenceRule
          ? 'Choose the hierarchy used to resolve parent-node and source attributes.'
          : 'Optionally scope this definition to a specific hierarchy.'
      }
      badge={isInferenceRule ? 'Required by rule' : 'Optional'}
    >
      <EditorField
        label={isInferenceRule ? 'Inference KTree' : 'KTree filter'}
        required={isInferenceRule}
        hint={isInferenceRule ? 'Parameter choices update after a hierarchy is selected.' : undefined}
      >
        <Autocomplete
          value={isInferenceRule ? inferenceKTreeDefinition : ktreeDefinition}
          options={kTreeOptions}
          loading={isLoading}
          disabled={disabled}
          getOptionLabel={(option) => option.label || ''}
          isOptionEqualToValue={(option, value) => String(option.value) === String(value.value)}
          onChange={(_, value) => (isInferenceRule ? onInferenceKTreeChange(value) : onKTreeChange(value))}
          sx={{ ...editorControlStyles, maxWidth: 620 }}
          renderInput={(params) => (
            <TextField
              {...params}
              size='small'
              placeholder={isInferenceRule ? 'Select an inference KTree' : 'No KTree filter'}
            />
          )}
        />
      </EditorField>
    </EditorSectionCard>
  );
}
